import { createSlice } from "@reduxjs/toolkit";
let labels = ['Box', 'STR', 'SP', 'FP', 'BP', 'AP', 'FAMILY']
let apiKey = ['box', 'straight', 'split_pair', 'front_pair', 'back_pair', 'any_two']
let numberIndex = ['012', '012', '02', '01', '12', '01']
let maxLength = [3, 3, 2, 2, 2, 2]
let panelWithInput = []

for (let index = 0; index < labels.length; index++) {
  let obj = {
    label: labels[index],
    apiKey: apiKey[index],
    check: index === 0 ? true : false,
    maxLength: maxLength[index],
    numberIndex: numberIndex[index]
  }
  panelWithInput.push(obj)
}

let dropdownValue = panelWithInput.slice(0, 2)
// console.log(dropdownValue, "dropdownValue")

export const selectPointList = ({ panelSlice }) => panelSlice.pointList
export const selectPanelWithInput = ({ panelSlice }) => panelSlice.panelWithInput
export const selectNumberFlag = ({ panelSlice }) => panelSlice.selectNumberFlag
export const selectNumberArray = ({ panelSlice }) => panelSlice.numberArray
export const selectNumberType = ({ panelSlice }) => panelSlice.numberType
export const selectRenderCardArray = ({ panelSlice }) => panelSlice.renderCardArray
export const selectRoundCardRender = ({ panelSlice }) => panelSlice.RoundCardRender
export const selectActiveBatPrice = ({ panelSlice }) => panelSlice.activeBatPrice
export const selectDropdownValue = ({ panelSlice }) => panelSlice.dropdownValue
export const selectActiveDropDownValue = ({ panelSlice }) => panelSlice.activeDropDownValue
export const selectEnterQt = ({ panelSlice }) => panelSlice.enterQt
export const selectTimeSloat3d = ({ panelSlice }) => panelSlice.timeSlot
export const selectRefreshCount = ({ panelSlice }) => panelSlice.refreshCount

const pointList = [
  { id: 0, label: 10, check: true },
  { id: 1, label: 20, check: false },
  { id: 2, label: 50, check: false },
  { id: 3, label: 100, check: false },
  { id: 4, label: 200, check: false },
  { id: 5, label: 500, check: false },
]

const numberType = [
  { id: 0, label: 'Single', check: true },
  { id: 1, label: 'Duplicates', check: false },
  { id: 2, label: 'Triples', check: false },
]

const panelSlice = createSlice({
  name: "panelSlice",
  initialState: {
    pointList: pointList,
    panelWithInput: panelWithInput,
    numberArray: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    selectNumberFlag: [false, false, false, false, false, false, false, false, false, false],
    numberType: numberType,
    renderCardArray: [],
    RoundCardRender: false,
    activeBatPrice: 10,
    dropdownValue: dropdownValue,
    activeDropDownValue: dropdownValue[0].label,
    enterQt: '',
    timeSlot: [],
    refreshCount: 0
  },
  reducers: {
    setPointList: (state, action) => {
      state.pointList = [...action.payload]
    },
    updatePanelWithInput: (state, action) => {
      state.panelWithInput = [...action.payload]
    },

    resetPanel: (state, action) => {
      state.panelWithInput = panelWithInput
      state.pointList = pointList
      state.selectNumberFlag = [false, false, false, false, false, false, false, false, false, false]
      state.numberType = numberType
      state.renderCardArray = []
      state.RoundCardRender = false
      state.activeBatPrice = 10
      state.activeDropDownValue = dropdownValue[0].apiKey
      state.enterQt = ''
      state.timeSlot = []
      state.refreshCount = state.refreshCount + 1
    },
    setSelectNumberFlag: (state, { payload }) => { state.selectNumberFlag = payload },
    setNumberType: (state, { payload }) => { state.numberType = payload },
    setRenderCardArray: (state, { payload }) => { state.renderCardArray = [...payload] },
    setRoundCardRender: (state, { payload }) => { state.RoundCardRender = payload },
    setActiveBatPrice: (state, { payload }) => { state.activeBatPrice = payload },
    setActiveDropDownValue: (state, { payload }) => { state.activeDropDownValue = payload },
    setEnterQt: (state, { payload }) => { state.enterQt = payload },
    setTimeSlot: (state, action) => {
      state.timeSlot = action.payload
    },
  }
});

export const { setPointList, updatePanelWithInput, resetPanel, setSelectNumberFlag, setNumberType, setRenderCardArray, setRoundCardRender, setActiveBatPrice,
  setActiveDropDownValue, setEnterQt, setTimeSlot } = panelSlice.actions

export default panelSlice.reducer;